module.exports = __webpack_public_path__ + "media/images/teams/logo__2-225631c14a13428ba169ac6c4ee04495.svg";